<template>
  <Layout>
    <PageHeader v-if="title" :title="title" :items="items" />
    <div v-if="stats.length" class="row">
      <div v-for="stat of stats" :key="stat.icon" :class="stat.wrapperClass || 'col-6 col-md-4 col-xl-3'">
        <Stat v-bind="stat" :loading="busy"/>
      </div>
    </div>
    <Loader no-axios>
      <div v-if="!lodash.isEmpty(filterColumns)" class="row">
        <model-filter
            v-model="filter"
            :columns="filterColumns"
            :modelVariable="modelVariable"
            :filterHandler="filterHandler"
        />
      </div>
      <div class="row">
        <model-index
            ref="table"
            class="col-12"
            :loading="loading"
            v-bind="$props"
            :columns="columns"
            :busy.sync="busy"
            :models-paginated="modelsPaginated"
            :page.sync="page"
            :per-page.sync="perPage"
            :from="from"
            :total="totalFiltered"
            :search.sync="search"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter-params.sync="filterParams"
            @create-click="handleCreate"
            @export-click="handleExport"
            @show-click="handleShow"
            @edit-click="handleEdit"
            @delete-click="handleDelete"
        >
          <template #card-tools="{emitCreateClick}">
            <b-button v-if="!denyCreate" @click="emitCreateClick" variant="primary" size="lg" class="rounded me-2">
              <span>
                <component :is="icons.Plus"></component>
              </span>
              <span style="font-size: 14px;">
                  {{ $t('Create New') }}
              </span>
            </b-button>
            <b-button
                v-if="!denyExport"
                class="me-2"
                size="lg"
                variant="success"
                @click="$bvModal.show('purchase-export-modal')"
            >
                <span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M11.464 0C14.176 0 16 1.904 16 4.728V11.264C16 14.096 14.176 16 11.464 16H4.528C1.8168 16 0 14.096 0 11.264V4.728C0 1.904 1.8168 0 4.528 0H11.464ZM8 4.136C7.664 4.136 7.4 4.4 7.4 4.736V9.816L5.424 7.832C5.312 7.72 5.152 7.656 5 7.656C4.8488 7.656 4.696 7.72 4.576 7.832C4.344 8.064 4.344 8.448 4.576 8.68L7.576 11.696C7.8 11.92 8.2 11.92 8.424 11.696L11.424 8.68C11.656 8.448 11.656 8.064 11.424 7.832C11.184 7.6 10.808 7.6 10.568 7.832L8.6 9.816V4.736C8.6 4.4 8.328 4.136 8 4.136Z"
                        fill="white"/>
                  </svg>
                </span>
              <span style="font-size: 14px;">
                  Unduh Data Beli
                </span>
            </b-button>
            <export-modal
                id="purchase-export-modal"
                title-class="font-18"
                size="sm"
                hide-footer
                hide-header
            >
              <h5 class="modal-header p-0">Unduh Data Beli</h5>
              <b-form-group
                  id="ordered-at-input-group"
                  :label="lodash.upperFirst($t('trips.purchase_date'))"
                  label-for="ordered-at-input"
                  style="color: #6C7589; margin-top: 16px"
                  :state="isExportOrderedAtValid"
                  :invalid-feedback="`*${$t('sale_notes.exports.validations.ordered_at {range}', {range : `3 ${lodash.lowerCase($t('Month'))}`})}`"
              >
                <datepicker-range
                    name="ordered_at"
                    v-model="exportOrderedAt"
                    :shortcuts="exportOrderedAtShorcuts"
                    :state="isExportOrderedAtValid"
                ></datepicker-range>
              </b-form-group>
              <div style="display: flex; justify-content: space-between; padding-top: 16px">
                <div style="width: 46%; float: left">
                  <b-button block variant="outline-dark" @click="$bvModal.hide('purchase-export-modal')">{{ $t('Cancel') }}</b-button>
                </div>
                <div style="width: 46%">
                  <b-button
                      block
                      variant="primary"
                      type="submit"
                      :disabled="!isExportOrderedAtValid || loadingExport"
                      @click="onSubmitExport"
                  >
                    <i
                        v-if="loadingExport"
                        class="bx bx-loader bx-spin me-2"
                    ></i>
                    {{ $t('Export') }}
                  </b-button>
                </div>
              </div>
            </export-modal>
          </template>
        </model-index>
        <component v-bind:key="modal" v-for="modal in modals" v-bind:is="modal"></component>
        <!-- <down-payment-form-modal -->
      </div>
    </Loader>
  </Layout>
</template>
<script>
import ModelFilter from '@/router/views/trips/filter'
import ModelIndex from "../models/index-v3"
import FileExcelIcon from "@/components/icons/FileExcel.vue";
import FileExcelDarkIcon from "@/components/icons/FileExcelDark.vue";
import ExportModal from "@/router/views/sale_notes/index/export-modal.vue";
import DatepickerRange from "@/components/inputs/filter/datepicker-range.vue";
import IconBase from "@/components/icon-base.vue";
import icons from '@/assets/icons';
import Swal from "sweetalert2";
import PageHeader from "@/components/page-header.vue";
import {hasAllowedAction as hasAllowedActionHelper} from "@/helpers/ui/allowedActions";

export default {
  extends: ModelIndex,
  components: {
    PageHeader,
    IconBase, DatepickerRange, ExportModal, FileExcelDarkIcon, FileExcelIcon,
    ModelFilter
  },
  page: {
    title: "Trips",
  },
  props: {
    // cardTitle: {default() { return this.lodash.startCase(this.$t('trips.plural')) }},
    resourceRoute: {default: 'trips'},
    modelVariable: {default: 'trip'},
    denyCreate: { type: Boolean, default() { return !this.$auth.hasPermissionTo('trips.create')} },
    denyExport: { type: Boolean, default() { return !this.$auth.hasPermissionTo('trips.export') } },
  },
  data() {
    return {
      icons,
      exportOrderedAt: [this.$moment().startOf('months').toDate(), this.$moment().endOf('months').toDate()],
      title: this.lodash.startCase(this.$t('trips.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('trips.plural')),
          href: "/trips",
          active: true,
        },
      ],
      sortBy: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').shift()) || 'ticket_id',
      sortDesc: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').pop() === 'desc') || true,
      filterColumns: {
        'ticketable.ticket_id__in': {
          type: Array,
          label: this.lodash.upperFirst(this.$t('tickets.ticket_id')),
          operator: 'in',
          input_component: 'ticket-multiselect-ajax'
        },
        where_has_purchase_order_id__in: {
          type: Array,
          label: this.lodash.upperFirst((this.$t('trips.purchase_order_id'))),
          input_component: 'purchase-order-multiselect-ajax',
          placeholder: this.lodash.upperFirst(this.$t(`Select {something}`, {something: this.$t('trips.purchase_order_id')})),
        },
        where_has_sub_product__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('products.singular')),
          // placeholder: this.lodash.upperFirst(this.$t(`Select {something}`, {something: this.$t('purchase_orders.product_service')})),
          operator: 'in',
          input_component: 'sub-product-multiselect',
        },
        'sale_order_id__in': {
          type: Array,
          label: this.lodash.upperFirst((this.$t('trips.sale_order_id'))),
          input_component: 'sale-order-multiselect-ajax',
          includeNullValue: true,
          params: {
            sort: 'id,desc',
            with_sub_product: 1,
          },
          searchKey: 'id',
          customLabel: function(value){
            if(value.id === 'not available') {
              return this.lodash.startCase(this.$t('not available'));
            }
            return `${value.sub_product} - ${value.id}`
          },
        },
        tripped_at__between: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('trips.tripped_at')),
          operator: 'between',
          input_component: 'datepicker-range',
        },
        vehicle_id: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('trips.vehicle')),
          operator: 'in',
          input_component: 'vehicle-multiselect-ajax',
        },
        customer_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('trips.factory_destination')),
          operator: 'in',
          input_component: 'factory-multiselect-ajax',
        },
      }
    }
  },
  computed: {
    isExportOrderedAtValid() {
      if (!this.exportOrderedAt.length) return false
      let endDateMoment = this.$moment(this.exportOrderedAt[1])
      let startDateMoment = this.$moment(this.exportOrderedAt[0])
      return endDateMoment.diff(startDateMoment, 'months', true) <= 3;
    },
    exportDatesLabel() {
      return this.exportOrderedAt.map(value => this.$moment(value).format('DD MMM YYYY')).join(' - ')
    },
    exportOrderedAtShorcuts() {
      let today = this.$moment()
      return {
        '7 hari lalu': [this.$moment().subtract(7, 'days').add(1, 'days').toDate(), today.toDate()],
        'Bulan ini': [this.$moment().startOf('months').toDate(), this.$moment().endOf('months').toDate()],
        '1 bulan lalu': [this.$moment().subtract(1, 'months').add(1, 'days').toDate(), today.toDate()],
        'Kuartal ini': [this.$moment().startOf('quarter').toDate(), this.$moment().endOf('quarter').toDate()],
      }
    },
    columns() {
      return {
        ['trip']: [
          { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
          {
            key: 'ticket_id',
            label: this.lodash.startCase(this.$t(`purchase_orders.ticket_id`)),
            thStyle: { minWidth: '100px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/tickets/${item.ticket_id}`" v-if="item.ticket_id">{{ `${item.ticket_id}: ${this.$t(`tickets.customer_types.${item.ticket.customer_type}`)}` }}</router-link><div v-else>-</div>'
            }
          },
          {
            key: 'id',
            label: this.lodash.startCase(this.$t(`trips.trip_id`)),
            thStyle: { minWidth: '100px' },
            sortable: true,
          },
          {
            key: 'trip_items.purchase_item.purchase_order_id',
            label: this.lodash.startCase(this.$t(`purchase_payments.purchase_order_id`)),
            thStyle: { minWidth: '100px' },
            // sortable: true,
            component: {
              props: ['item'],
              template: '<div><template v-for="(purchaseOrder, index) in item.purchase_orders"><router-link :to="`/purchase_orders/${purchaseOrder.id}`">{{ `${purchaseOrder.id}` }}</router-link><span v-if="index !== (item.purchase_orders || []).length - 1">, </span></template></div>'
            }
          },
          {
            key: 'sale_order.id',
            label: this.lodash.startCase(this.$t(`trips.sale_order_id`)),
            thStyle: { minWidth: '100px' },
            sortable: true,
            component: {
              props: ['item'],
              computed: {
                formattedId(){
                  return `${this.item.type_name} - ${this.item.sale_order.id}`
                }
              },
              template: `
                <div>
                  <router-link v-if="item.sale_order" :to="'/sale_notes/'+item.sale_order.id">{{formattedId}}</router-link>
                  <router-link v-else :to="{
                      name: 'unload.create',
                      params: {
                        ticketable: {
                          ticket_id: item.ticket_id,
                        },
                        trip_id: item.id,
                      }
                  }">
                    <div class="text-red-500 bg-red-100 px-8px py-1px badge">ID Belum Tersedia</div>
                  </router-link>
                </div>
              `
            }
          },
          {
            key: 'tripped_at',
            label: this.lodash.startCase(this.$t('trips.tripped_at')),
            thStyle: { minWidth: '125px' },
            sortable: true,
            component: {
              props: ['item'],
              template:
              '<div v-if="item.tripped_at" style="width: 125px" class="text-truncate" :title="item.tripped_at">{{ $moment.utc(item.tripped_at).local().format(`DD MMM YYYY`) }}</div>'+
              '<div v-else>-</div>'
            }
          },
          {
            key: 'vehicle.name',
            label: this.lodash.startCase(this.$t('trips.vehicle')),
            thStyle: { minWidth: '200px' },
            sortable: true,
            component: {
              props: ['item'],
              computed: {
                customLabel () {
                  return `${this.lodash.upperFirst(this.vehicleName)} - ${this.item?.vehicle?.license_plate}`
                },
                vehicleName () {
                  let vehicle = this.item?.vehicle
                  let label = vehicle.name

                  if (vehicle.type === 'heavy') label = this.$t('vehicles.truck')
                  else if (vehicle.type === 'medium') label = this.$t('vehicles.crank_truck')
                  else if (vehicle.type === 'light') label = this.$t('vehicles.pickup')

                  return label
                },
              },
              template:
              '<router-link v-if="item.vehicle" :to="`/vehicles/${(item.vehicle || {}).id}`">{{ customLabel }}</router-link>' +
              '<div v-else>-</div>'
            }
          },
          {
            key: 'customer.name',
            label: this.lodash.startCase(this.$t('trips.factory_destination')),
            sortable: true,
            component: {
              props: ['item'],
              methods: {
                format({type, customer}) {
                  if(type === 'hybrid') return '-'
                  return customer.name ?? '-'
                }
              },
              template: '<span>{{format(item)}}</span>'
            }
          },
          {
            key: 'creator.name',
            label: this.lodash.startCase(this.$t('trips.created_by')),
          },
          { key: 'action', label: this.$t('Action'), class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    onSubmitExport() {
      this.loadingExport = true
      let exportParams = {
        search: this.search,
        sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        with: [
        ].join(','),
        ...this.$route.params,
        ...this.filterParams,
        tripped_at__between: this.exportOrderedAt.map(value => this.$moment(value).format('YYYY-MM-DD')).join(','),
      }
      return this.$axios.get('/trips', {
        params: exportParams
      }).then(res => {
        let { data: { data, meta: { total }} } = res

        if (total === 0) {
          throw {
            status: 200,
            data
          }

        }

        return this.$axios.get('/purchase_export_excel', {
          responseType: 'blob',
          params: exportParams,
        })
      })
          .then(res => {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', `Purchase Invoices - ${this.exportDatesLabel}${this.activePillButton === 'pdf' ? '.pdf' : '.xlsx'}`); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
            return res
          }).catch((error) => {
            if (error.status === 200 && error.data.length === 0) {
              return Swal.fire({
                title: this.$t('Warning') + '!',
                text: this.lodash.upperFirst(this.$t('sale_notes.exports.validations.there is no data to export between {something}', {
                  something: this.exportDatesLabel
                })),
                type: 'warning',
                confirmButtonClass: 'btn btn-warning btn-fill',
                buttonsStyling: false
              })
            }
            return Swal.fire({
              title: this.lodash.startCase(this.$t('failed')),
              text: this.lodash.upperFirst(this.$t('download_failed')),
              type: 'danger',
              confirmButtonClass: 'btn btn-danger btn-fill',
              buttonsStyling: false
            })
          }).finally((res) => {
            this.loadingExport = false
            return res
          })
    },
    delete(value) {
      return this.$axios.delete(`/trips/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      let vm = this
      return this.$axios.get('/trips', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          with: [
            'customer',
            'trip_items.purchase_order.purchase_items',
            'trip_items.purchase_order.ticket',
            'trip_items.purchase_order.customer',
            'vehicle',
            'driver',
            'creator',
            'sale_order',
          ].join(','),
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta = {} } } = response;
        this.models = data.map(function (datum) {
          let purchaseOrders = []
          datum.trip_items.forEach(tripItem => {
            let purchaseOrderIds = purchaseOrders.map(purchaseOrder => purchaseOrder.id)
            if (!purchaseOrderIds.includes(tripItem.purchase_order.id)) {
              purchaseOrders.push(tripItem.purchase_order)
            }
          })
          let purchaseOrder = datum.trip_items.length ? (vm.lodash.uniq(datum.trip_items.map(function (item) {
            let po = item.purchase_order
            return `${po.id} (${po.customer.name} - ${vm.$moment.utc(po.ordered_at).local().format('DD MMM YYYY')})`
          })).join(', ')) : ''
          let purchaseItems = datum.trip_items.length ? (vm.lodash.uniqBy(vm.lodash.flatten(datum.trip_items.map(i => i.purchase_order.purchase_items)), 'id')) : []
          let total_purchase_items = purchaseItems.length ? purchaseItems.reduce((total, v) => total + ((v.quantity - v.trip_item_total_quantity - v.sale_item_total_quantity) || 0), 0) : 0
          let total_trip_items = datum.trip_items.length ? datum.trip_items.reduce((total, v) => total + (v.quantity || 0), 0) : 0
          const policies = vm.modelPolicy(datum);
          if(datum.sale_order) {
            policies._denyDelete = true;
            policies._denyEdit = true;
          }
          return {
            ...datum,
            ...policies,
            ticket: datum.trip_items.length ? datum.trip_items[0].purchase_order.ticket : null,
            purchase_order: purchaseOrder,
            purchase_orders: purchaseOrders,
            total_purchase_items: total_purchase_items,
            total_trip_items: total_trip_items,
            total_difference: total_purchase_items - total_trip_items,
          }
        })
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        this.stats = []

        return response;
      }).catch((error) => this.failedAlert(error));
    },
    hasAllowedAction(model, actions) {
      return hasAllowedActionHelper(model, actions);
    },
    modelPolicy(model) {
      return {
        _denyShow: false,
        _denyEdit: !this.hasAllowedAction(model, ["edit", "update"]),
        _denyDelete: !this.hasAllowedAction(model, ["delete", "destroy"]),
      }
    },
  },
};
</script>
